import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=c8c106c4&"
import script from "./order-table.vue?vue&type=script&lang=js&"
export * from "./order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports